import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import {
  FlaggedPatient,
  FlagUpdateType,
  UserFacade,
} from '@cigna/chcp/shared/user-profile-data-access';

@Component({
  selector: 'cigna-patients-tile',
  templateUrl: './patients-tile.component.html',
  styleUrls: ['./patients-tile.component.scss', '../tile.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PatientsTileComponent {
  @Input() isEditable = true;
  @Input() isRestrictedImpersonator = false;

  isFlaggedPatientToggled = false;

  patientDashboardData$ = this.userFacade.patientDashboardData$;

  constructor(private userFacade: UserFacade) {}

  updateFlaggedPatients(data: {
    checked: boolean;
    patients: FlaggedPatient[];
  }) {
    this.userFacade.updateFlaggedPatients(
      data.checked ? FlagUpdateType.remove : FlagUpdateType.add,
      data.patients,
    );
  }

  toggle() {
    this.isFlaggedPatientToggled = !this.isFlaggedPatientToggled;
  }
}
